import { AbstractReactFactory } from "@projectstorm/react-canvas-core";
import { DefaultNodeModel } from "@projectstorm/react-diagrams";
import { DiagramEngine } from "@projectstorm/react-diagrams-core";
import { CustomNodeWidget } from "./CustomNodeWidget";
import { DiamondNodeModel } from "./DiamondNodeModel";

export class DiamondNodeFactory extends AbstractReactFactory<DiamondNodeModel, DiagramEngine> {
  constructor() {
    super("diamond");
  }

  generateReactWidget(event): JSX.Element {
    return <CustomNodeWidget engine={this.engine} size={150} node={event.model} />;
  }

  generateModel() {
    return new DefaultNodeModel();
  }
}
